export default __webpack_public_path__ + "ad6e79fd16824936899087348d08de07.png";